import { PatchPublishedEntryMutation } from 'scripts/constants'
import { fetch, getStorageKey, Storage } from 'scripts/utils'
import { FieldEntry } from 'scripts/type'

export default function patchPublishedEntry(fieldEntries: FieldEntry[], urlToken: string): Promise<any> {
  const variables = {
    formId:
      Storage.getItem(getStorageKey('publishedFormToken', urlToken)) ||
      Storage.getItem(getStorageKey('urlPublishedFormToken', urlToken)),
    publishedEntryId: Storage.getItem(getStorageKey('publishedEntryId', urlToken)),
    fieldEntries,
  }

  return new Promise((resolve, reject) => {
    fetch({
      input: {
        query: PatchPublishedEntryMutation,
        variables: variables,
      },
      successCallback: ({ data }) => {
        resolve(data.patchPublishedEntry.nextFields)
      },
      errorCallback: (data) => {
        return reject(data)
      },
    })
  })
}
